import React from "react";
import TopBar from "../../Components/topBar/topBar";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import AddReason from "../Registration/Reason/addReasonView";
import AltReason from "../Registration/Reason/altReason";
import DelReason from "../Registration/Reason/delReason";
import "./prelude.css";
import BottomBar from "../../Components/bottomBar/bottomBar";
import MessageTable from "../../Components/messageTable/MessageTable";
import Alert from "../../Components/alert/Alert";
import Api from "../../services/api";
import TableList from "../../Components/tableList/TableList";
import { Redirect } from "react-router-dom";
import { handleColor } from "../../services/Functions";
import ReportReasons from "../Reports/reportReasons";
class prelude_motivo extends React.Component {
  render() {
    return (
      <>
        <header>
          <TopBar />{" "}
        </header>
        <div className="prelude_container">
          <Sidebar></Sidebar>
        </div>
        <BottomBar></BottomBar>
      </>
    );
  }
}

class Sidebar extends React.Component {
  state = {
    data: [],
    keys: [],
    render: false,
    message: "",
    redirect: false,
    click: false,
  };

  async componentDidMount() {
    let array = [];
    await Api.get("/reasons-stop")
      .then((response) => {
        response.data.response.forEach((element) => {
          array.push({
            Código: element.code,
            Motivos: element.description,
            ["Programada"]: element.planned_stop ? "Sim" : "Não",
            ["Bloqueio"]: element.block_machine ? "Sim" : "Não",
            ["Andon"]: element.tracking ? "Sim" : "Não",
            ["FTQ"]: element.ftq_count ? "Sim" : "Não",
          });
        });
        if (array.length > 0) this.setState({ data: array, render: true });
      })
      .catch((err) => {
        this.setState({ message: "" });
      });
    let viewport = document.querySelector("meta[name=viewport]");
    viewport.setAttribute(
      "content",
      viewport.content + ", height=" + window.innerHeight
    );
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const { show, message, redirect } = this.state;

    if (redirect) return <Redirect to="/refugos"></Redirect>;

    return (
      <Tab.Container defaultActiveKey="list">
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1">
            <div className="sidebar2">
              <Col className="sidebarColumn " mountOnEnter unmountOnExit>
                <ListGroup>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg1"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="list"
                  >
                    Motivos de parada
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg2"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="add"
                  >
                    Adicionar motivo
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg3"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="alt"
                  >
                    Alterar motivo
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg4"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="del"
                  >
                    Deletar motivo
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg5"
                    onClick={handleColor}
                    className="listGroup"
                    onClick={() => this.setState({ redirect: true })}
                    eventKey="refuse"
                  >
                    Refugos
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </div>

            <Col
              className="col3"
              style={{
                top: "5%",
                marginLeft: "1.5%",
                width: "100%",
                height: "78vh",
              }}
            >
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              <Tab.Content style={{ height: "90%" }}>
                <Tab.Pane eventKey="list">
                  {this.handleClick ? <ReportReasons /> : null}
                </Tab.Pane>
                <Tab.Pane
                  mountOnEnter
                  unmountOnExit
                  eventKey="add"
                  style={{ height: "100%" }}
                >
                  {this.handleClick ? <AddReason /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="alt">
                  {this.handleClick ? <AltReason /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="del">
                  {this.handleClick ? <DelReason /> : null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_motivo;
